module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av327-aded5ea9d5bd8c0d3397828b56543e99.jpg";